module.exports = __webpack_public_path__ + "img/wangketong-banner.d861b8f5.png";